const cacheConfig = {
	checkCacheInterval: 1000*60, // Time interval in minutes to check if data is stale and refetch.
	SSAExpire: 24*5, // Expiration time in hours for SSAs features = 24 days.
	weatherExpire: 1, // Weather info expiration time in hours.
	burnsExpire: 24, // Prescribed burns expiration time in hours.
}

export default cacheConfig;